module.exports = __webpack_public_path__ + "img/avatar.b769eff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = lS+k
// module chunks = 1